$(document).on("click", '[data-show-product-get-offer-modal]', function (e) {

    $('.modal').modal('hide')
    $('.mfp-bg').click()

    const modal = $('#product-get-offer-modal');

    modal.find('[name=product_unique_id]').val($(this).attr('data-show-product-get-offer-modal'))
    modal.find('[name=product]').val($(this).attr('data-product-name'))

    modal.modal('show');

});

$(document).on("submit", '#product-get-offer-modal form', function (e) {

    e.preventDefault();

    const form = $('#product-get-offer-modal form');

    $.ajax({
        type: 'POST',
        url: form.attr('action'),
        dataType: "json",
        data: form.serialize(),
        success: function (response) {

            App.prototype.notificationSuccess(response.message);

            form.parents('#product-get-offer-modal').modal('hide');

        },
        error: function (response){

            const error = response.responseJSON && response.responseJSON.error ? response.responseJSON.error : '';

            App.prototype.notificationError(error);

        }
    });

});
